
import { listStoreBuilder } from '@/main/store/pages/list/builder';
import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { DropdownItem } from '@/main/store/@types/dropdown.d';
import { apiProvider } from '../api';


const filter = {
	FromDate: null as Date | null,
	ToDate: null as Date | null,	
	LocationIds: null as number | null
};
export interface DropDownListItem<T> {
    Value: T;
}

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		LocationIds: []
	},
	filter,
	tableSetting: { },
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
